import { useEffect } from 'react';

export const APP_TITLE = 'Ropere admin';

export function useDocumentTitle(title: string | undefined): void {
  useEffect((): (() => void) | undefined => {
    if (!title) {
      return undefined;
    }

    const previousTitle: string = document.title;
    document.title = `${title} · ${APP_TITLE}`;

    return (): void => {
      document.title = previousTitle;
    };
  }, [title]);
}
